import Api from './api.service'

export default {
  createUser (userObject) {
    return Api().post('user/create', userObject)
  },
  updateUser (roleObject) {
    return Api().patch('user/edit/' + roleObject.id, roleObject.object)
  },
  getUser (id) {
    return Api().get('user/get/' + id)
  },
  UsersList (filter) {
    return Api().get('user/list', { params: filter })
  },
  getRoleName () {
    return Api().get('role/getName')
  },
  getRolesList () {
    return Api().get('role/get')
  },
  profile () {
    return Api().get('user/profile')
  },
  removeProfileImage (object) {
    return Api().post('media/' + object.id, object.data)
  },
  updateProfile (object) {
    return Api().patch('user/profile', object)
  },
  deleteRequest (object) {
    return Api().delete(object.module + '/' + object.id)
  },
  getDashboardDetails () {
    return Api().get('user/getDashboardDetails')
  },
}